import React from "react";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import zget from "zget";
import { api } from "../services/index";
import { dispatch } from "../recontext/store";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    borderRadius: 8
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  }
});

class ButtonLogin extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleClickLogin = this.handleClickLogin.bind(this);
  }

  async handleClickLogin() {
    const result = await api.login();
    const userId = zget(result, "user.uid");

    if (!zget(result, "additionalUserInfo.isNewUser")) {
      await api.getMe();
      window.location.reload();
      return;
    }

    const userData = {
      id: userId,
      teamId: userId,
      displayName: zget(result, "user.displayName") || "",
      email: zget(result, "user.email") || "",
      photoUrl: zget(result, "user.photoURL") || "",
      intro: "",
      lookingFor: ""
    };
    const teamData = {
      id: userId,
      name: "untitled",
      track: "",
      intro: "",
      members: [userData]
    };
    localStorage.setItem("USER_DATA", JSON.stringify(userData));
    dispatch("ADD_USER_AND_TEAM", { user: userData, team: teamData });
    dispatch("SHOW_CREATE_PROFILE_DIALOG");
    await api.getTeams();
  }

  render() {
    const { classes } = this.props;
    return (
      <Button
        variant="contained"
        color="primary"
        size="large"
        className={classes.button}
        onClick={this.handleClickLogin}
      >
        <Icon className={classes.leftIcon}>account_circle</Icon>
        Log in With Facebook
      </Button>
    );
  }
}

export default withStyles(styles)(ButtonLogin);
